import { INCIDENT_RULES } from '@/utils/routes'

/**
 * Href of a rule's detail page: v2 rules live under `automation`, everything
 * else under `rule`. The trailing slash matches next.config's
 * `trailingSlash: true` so a link opened in a new tab (outside the Next
 * router) skips a redirect.
 */
export const getRuleHref = (id: string, isV2: boolean | null | undefined) =>
  `${INCIDENT_RULES}/${isV2 ? 'automation' : 'rule'}/?id=${encodeURIComponent(
    id
  )}`
